import { Toast } from "vant";
import HttpClient from "@/utils/HttpClient";
import GPopup from "@/components/common/GeneralPopup";
import LoadPage from "@/components/common/LoadPage";
import { allLogin } from "@/utils/common";

export const httpInstance = new HttpClient(
  {
    timeout: 0,
    baseURL: process.env.VUE_APP_APP,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      "x-requested-with": "XMLHttpRequest",
      "login-channel": "s"
    }
  },
  {
    requestStart: function(config) {
      if (config.loadPopup) {
        Toast.loading({
          duration: 0, // 持续展示 toast
          mask: true,
          forbidClick: true, // 禁用背景点击
          loadingType: "spinner",
          message: "请求中..."
        });
      }
    },
    requestEnd: function() {
      Toast.clear();
      LoadPage.clear();
    }
  }
);

// 响应拦截
httpInstance.axiosInstance.interceptors.response.use(
  response => {
    return response.data;
  },
  error => {
    // 服务超时
    if (error.message.indexOf("timeout") !== -1) {
      GPopup("请求超时！");
    }

    // 错误处理
    if (error.response) {
      // 权限失效
      if (error.response.status === 999) {
        allLogin();
        return false;
      }
      if (error.response.status === 401 && error.response.status === 403) {
        GPopup("暂无权限...");
        return false;
      }
      if (error.response.status === 404) {
        GPopup("服务找不到...");
        return false;
      }

      if (error.response.status >= 500) {
        GPopup("网络异常...");
        return false;
      }
    }

    return Promise.reject(error);
  }
);

export const createSequenceHttps = httpInstance.createSequenceHttps;
export default httpInstance.createHttp;
